import { ElementProps } from '@/types/elements';

import { InlineWidget } from "react-calendly";
import { useModal } from '@/lib/hooks/useModal';

import { getBorderRadius } from '@/lib/util';
import { ArrowUpRight, Calendar } from 'react-feather';


export default function CalendlyElement({ block: { id: blockId, data }, viewMode, tracer, appearance }: ElementProps) {
    const { openModal } = useModal();
    let { title, link } = data;
    const onClick = () => {
        openModal(<InlineWidget url={link} />, title)
        tracer?.trackClick({ blockId, meta: {} })
    }

    return (
        <div className="w-full transition duration-500 hover:scale-105">
            <button onClick={onClick}
                className="inline-flex justify-between w-full px-4 py-3 duration-1000 ease-in-out transform border button-link drop-shadow-xl group">
                <div className="flex flex-row items-center justify-center space-x-2">
                    <Calendar className="stroke-[1.5]" />
                    <span>{title}</span>
                </div>
                <ArrowUpRight className="transition stroke-[1.5] duration-400 group-hover:rotate-45" height={24} width={24} />
            </button>

            <style jsx>{`
                .button-link {
                    color: ${appearance?.buttonTextColor};
                    border-radius: ${getBorderRadius(appearance!)};
                    background-color: ${appearance?.buttonBackgroundColor};
                    border-color: ${appearance?.buttonBackgroundColor};
                }
                .button-link:hover {
                    color: ${appearance?.buttonBackgroundColor};
                    background-color: white;
                }
          `}</style>
        </div>
    )
}
